module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }